export default function CircularProgress({ value, label, color, growth }) {
  const circumference = 2 * Math.PI * 70;
  const percentage = 75;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  return (
    <div className="card-wrapper !p-4 !rounded-2xl relative hover:scale-105 transition-transform cursor-pointer">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-black">{label}</h3>
        {growth !== undefined && (
          <div
            className={`flex items-center gap-1 px-2 py-1 rounded-lg ${
              growth >= 0
                ? 'text-emerald-400 bg-emerald-400/10'
                : 'text-red-400 bg-red-400/10'
            }`}
          >
            <span className="text-sm font-medium">
              {growth >= 0 ? '▲' : '▼'} {Math.abs(growth)}%
            </span>
          </div>
        )}
      </div>
      <div className="flex items-center justify-center">
        <div className="relative w-48 h-48">
          <svg className="w-full h-full transform -rotate-90">
            <circle
              cx="96"
              cy="96"
              r="70"
              stroke="currentColor"
              strokeWidth="12"
              fill="none"
              className="text-gray-700"
            />
            <circle
              cx="96"
              cy="96"
              r="70"
              stroke="currentColor"
              strokeWidth="12"
              fill="none"
              strokeDasharray={circumference}
              strokeDashoffset={strokeDashoffset}
              strokeLinecap="round"
              className={color}
            />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <div className="text-3xl font-bold text-black">{value}</div>
            <div className="text-sm text-gray-600 mt-1">{label}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
